export const body = document.querySelector("body");
export const navbar = document.querySelector(".navbar");
export const toTop = document.querySelector(".to-top");
export const adminBar = document.querySelector("#wpadminbar");
